import { Button } from 'antd';
import { useWindowSize } from 'react-use';
import { isTabletBrowser } from '../common/utils';
import useRouter from '../hooks/useRouter';
import DownloadSharePdf from '../modules/vastu-assessment-report/components/DownloadSharePdf';
import './sidebar.less';

type SidebarProps = {
  onSave?: () => void;
  bodyContent: React.ReactNode;
  headerContent: React.ReactNode;
  loading?: boolean;
  isAnnotationScreen?: boolean;
};

export default function Sidebar({
  onSave,
  bodyContent,
  headerContent,
  loading = false,
  isAnnotationScreen = false,
}: SidebarProps) {
  const { width } = useWindowSize();
  const { navigate, location } = useRouter();
  const buttonText = location.pathname === '/choose-entrance' ? 'Save' : 'Next';
  const isReportPage = location.pathname.startsWith('/report/');

  return (
    <>
      <div
        className="sidebar"
        style={{ display: !isTabletBrowser(width) ? 'flex' : 'none' }}
      >
        <div className="sidebar-header">{headerContent}</div>
        <div
          className={`sidebar-content-part ${isAnnotationScreen ? 'annotation-sidebar' : ''}`}
        >
          {bodyContent}
        </div>
        <div className="sidebar-footer">
          <div className="sidebar-footer-content">
            {isReportPage ? (
              <div className="full-width">
                <DownloadSharePdf />
              </div>
            ) : (
              <>
                <Button
                  type="default"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Previous
                </Button>
                <Button loading={loading} type="primary" onClick={onSave}>
                  {buttonText}
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
